import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box } from "@mui/material";
import constant from "@/utils/constant";
import { Controller, useFormContext } from "react-hook-form";
import dayjs from "dayjs";

const Calendar: React.FC = () => {
    const SPACING = constant.GRID_SPACING;
    const { control } = useFormContext();

    return (
        <Box display="flex" gap={SPACING}>
            <Controller
                name="startDate"
                control={control}
                render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker", "DatePicker"]}>
                            <DatePicker
                                label="Start date"
                                value={field.value ? dayjs(field.value) : null}
                                onChange={newValue => {
                                    field.onChange(newValue ? newValue.toISOString() : null);
                                }}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                )}
            />
            <Controller
                name="endDate"
                control={control}
                render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker", "DatePicker"]}>
                            <DatePicker
                                label="End date"
                                value={field.value ? dayjs(field.value) : null}
                                onChange={newValue => {
                                    field.onChange(newValue ? newValue.toISOString() : null);
                                }}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                )}
            />
        </Box>
    );
};

export default Calendar;
